import { createSelector } from 'reselect';
import { getActiveAccounts } from 'state/account/AccountSelectors';
import { filterFunctionMapping } from 'state/shared/FilterFunctionMappingUtil';
import { isCollegeSavings, products } from 'services/Products';

const getAccountFilteringSelections = (state) =>
  state.accountFilteringSelections;

export const getAccountFilters = createSelector(
  getActiveAccounts,
  getAccountFilteringSelections,
  (activeAccounts, selections) => {
    return {
      ...selections.filtering,
      options: selections.filtering.options.filter(({ value, accountIds }) =>
        activeAccounts.some(
          filterFunctionMapping(value, products.providers, accountIds)
        )
      )
    };
  }
);

export const getAccountGrouping = createSelector(
  getAccountFilteringSelections,
  (accountGroupingSelections) => accountGroupingSelections.grouping
);

export const getAssetAllocationAccountFilters = createSelector(
  getAccountFilters,
  ({ selection, options }) => ({
    selection,
    options: options.filter(
      (option) => !['529', 'activePlus'].includes(option.value)
    )
  })
);

export const getPortfolioAllocationAccountGroupsMap = createSelector(
  getActiveAccounts,
  getAccountFilteringSelections,
  (activeAccounts, { filtering: { options } }) => { 
    const visibleAccounts = activeAccounts.filter(({ productType }) => !isCollegeSavings(productType));
    const groups = {};
    options
      .filter((option) => !['529', 'all'].includes(option.value))
      .forEach(({ label, value, accountIds }) => {
        const filteredAccounts = visibleAccounts.filter(filterFunctionMapping(value, products.providers, accountIds));
        if (filteredAccounts.length > 0) {
          groups[value] = {
            label,
            value,
            accountIds: filteredAccounts.map(({accountId})=>accountId)
          }
        }
      });
    return groups;
  }
);
